<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/quotations/quotations.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Cotización', plural:'Cotizaciones'}"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useQuotationsStore } from '@/store/quotations';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/quotations/quotations.config';
import { useRoute } from 'vue-router';

import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();
const quotationsStore = useQuotationsStore();


const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => quotationsStore.fetchQuotations(params),
  {
    create: quotationsStore.createQuotation,
    update: (data) => quotationsStore.updateQuotation(data.id, data),
    remove: quotationsStore.deleteQuotation,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => quotationsStore.quotations);

</script>
